import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-auto-curate-modal',
    templateUrl: './auto-curate-modal.component.html',
    styleUrls: ['./auto-curate-modal.component.scss'],
})
export class AutoCurateModalComponent {
    @Input() data: any;
    autoCurateModalData: any = [];
    readonly DEFAULT_IMAGE = '../../assets/images/default-image.png';
    ngOnInit() {
        console.log('THIS.DATA', this?.data);

        if (Array.isArray(this.data)) {
            this.autoCurateModalData = this.data.map((item: any) => {
                return {
                    Name: item?.metadata?.name,
                    ContentId: item?.contentId,
                    Image: item?.imageURL ? item.imageURL : this.DEFAULT_IMAGE,
                    Schedule: item?.schedule || [],
                };
            });
        } else {
            console.warn('Data is not an array:', this.data);
        }
    }
}
